import { Goal } from '@griply/types';
import { t } from 'i18next';
import React, { useRef } from 'react';
import { Tooltip } from 'shared/components/ui/tooltip';
import { useTaskCounts } from 'shared/contexts/task-counts/use-task-counts';
import { useOpenCreateTask } from 'shared/contexts/task-detail';

import * as Styled from './goal-list-card.style';

export type TasksCellProps = {
  goal: Goal;
};

export const TasksCell: React.FC<TasksCellProps> = ({ goal }) => {
  const taskCounts = useTaskCounts();
  const openCreateTask = useOpenCreateTask();
  const tasksButtonRef = useRef<HTMLSpanElement>(null);

  const uncompletedTasks = taskCounts?.byGoalId.get(goal.id) ?? 0;
  const canCreate = !goal.frozenAt;

  const onCreateTaskClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    openCreateTask({ goalId: goal.id });
  };

  return (
    <>
      <Styled.DataContainer
        $type={Styled.DataTypes.Tasks}
        $isFrozen={!!goal.frozenAt}
        $isClickable={canCreate}
        onClick={canCreate ? onCreateTaskClick : undefined}
      >
        {!!taskCounts && (
          <Styled.DataButton ref={tasksButtonRef} $static={!canCreate}>
            <Styled.TaskCount $isEmpty={!uncompletedTasks}>
              {uncompletedTasks}
            </Styled.TaskCount>
          </Styled.DataButton>
        )}
      </Styled.DataContainer>

      {!!taskCounts && (
        <Tooltip
          referenceElement={tasksButtonRef}
          label={t('general.labels.task-count', { count: uncompletedTasks })}
        />
      )}
    </>
  );
};
